import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
  children: React.ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  fullWidth = false,
  children,
  className = "",
  ...props
}: ButtonProps) {
  const baseStyles =
    "font-bold rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

  const variantStyles = {
    primary:
      "bg-[#8b5cf6] text-white hover:bg-[#7c3aed] focus:ring-[#8b5cf6] active:bg-[#6d28d9]",
    secondary:
      "bg-white text-black hover:bg-gray-100 focus:ring-gray-400 active:bg-gray-200",
    outline:
      "bg-transparent border-2 border-[#8b5cf6] text-[#8b5cf6] hover:bg-[#8b5cf6]/10 focus:ring-[#8b5cf6]",
  };

  const sizeStyles = {
    sm: { padding: "0.75rem 2rem", minHeight: "44px", fontSize: "0.875rem" },
    md: { padding: "0.875rem 3rem", minHeight: "48px", fontSize: "1rem" },
    lg: { padding: "1rem 4rem", minHeight: "52px", fontSize: "1.125rem" },
  };

  const widthStyles = fullWidth ? "w-full" : "";

  return (
    <button
      className={`${baseStyles} ${variantStyles[variant]} ${widthStyles} ${className}`}
      style={
        typeof sizeStyles[size] === "object" ? sizeStyles[size] : undefined
      }
      {...props}
    >
      {children}
    </button>
  );
}
